import ReferralClients from 'modules/Referral/ReferralClients/ReferralClients'
import Reducer from 'modules/Referral/ReferralClients/reducer'
import Sagas from 'modules/Referral/ReferralClients/saga'

export default ReferralClients

export { Reducer, Sagas as Sagas }
